/**
 * 布局组件
 */
import EspPage from './layout/EspPage'
import EspPageBack from './layout/EspPageBack'
import EspPageAside from './layout/EspPageAside'
import EspPageHeader from './layout/EspPageHeader'
import EspPageMain from './layout/EspPageMain'
import EspPageFooter from './layout/EspPageFooter'
import EspSearchItem from './layout/EspSearchItem'
import EspPageCard from './layout/EspPageCard'
/**
 * 对话框
 */
import EspElDialog from './dialog/EspElDialog'
/**
 * 通用组件
 */
import EspEnumEdit from './common/enum/EspEnumEdit' // 枚举编辑
import EspEnumView from './common/enum/EspEnumView' // 枚举查看
/**
 * 基础模块
 */
//公司
import EspCorp from "./base/corp/EspCorp";
//部门
import EspDeptdoc from "./base/deptdoc/EspDeptdoc";
import EspDeptdocView from "./base/deptdoc/EspDeptdocView";
//人员
import EspPsndoc from "./base/psndoc/EspPsndoc";
import EspPsndocM from "./base/psndoc/EspPsndocM";
import EspPsndocView from "./base/psndoc/EspPsndocView";


export default [
  //布局
  EspPage,
  EspPageBack,
  EspPageAside,
  EspPageHeader,
  EspPageMain,
  EspPageFooter,
  EspSearchItem,
  EspPageCard,
  EspElDialog,
  EspEnumEdit,
  EspEnumView,

  //基础模块
  EspCorp,
  EspDeptdoc,
  EspDeptdocView,
  EspPsndoc,
  EspPsndocM,
  EspPsndocView
]



// WEBPACK FOOTER //
// ./src/components/common.js